/*
 * Facebox (for jQuery)
 * version: 1.2 (05/05/2008)
 * @requires jQuery v1.2 or later
 *
 * Examples at http://famspam.com/facebox/
 *
 * Licensed under the MIT:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2007, 2008 Chris Wanstrath [ chris@ozmm.org ]
 *
 * Usage:
 *
 *    jQuery.facebox('some html')
 *
 *  The above will open a facebox with "some html" as the content.
 *
 *    jQuery.facebox(function($) {
 *      $.get('blah.html', function(data) { $.facebox(data) })
 *    })
 *
 *  The above will show a loading screen before the passed function is called,
 *  allowing for a better ajaxy experience.
 *
 *  Want to close the facebox?  Trigger the 'close.facebox' document event:
 *
 *    jQuery(document).trigger('close.facebox')
 */
import $ from 'jquery';
import {addResizeListener, removeResizeListener} from './element-detect-resize';

(function($) {
  $.facebox = function(data, klass) {
    $.facebox.loading()

    if (data.ajax) fillFaceboxFromAjax(data.ajax)
    else if (data.image) fillFaceboxFromImage(data.image)
    else if (data.div) fillFaceboxFromHref(data.div)
    else if ($.isFunction(data)) data.call($)
    else $.facebox.reveal(data, klass)
  }

  /*
   * Public, $.facebox methods
   */

  $.extend($.facebox, {
    settings: {
      opacity      : 1,
      overlay      : true,
      imageTypes   : [ 'png', 'jpg', 'jpeg', 'gif' ],
      faceboxHtml  : '\
    <div id="facebox" class="cobot-modal" style="display:none;"> \
      <div class="content"> \
      </div> \
      <a href="#" class="close facebox-close"> \
        <svg enable-background="new 0 0 20 20" style="width: 20px; height: 20px" alt="Close" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.4 10 7.8-7.8c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-7.8 7.8-7.8-7.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l7.8 7.8-7.8 7.8c-.4.4-.4 1 0 1.4s1 .4 1.4 0l7.8-7.8 7.8 7.8c.4.4 1 .4 1.4 0s.4-1 0-1.4z" fill="currentColor"/></svg>\
      </a> \
    </div>'
    },

    loading: function() {
      init()
      if ($('#facebox_overlay .loading').length == 1) {
        return true;
      }

      $('#facebox_overlay').empty();
      showOverlay();

      $(document).trigger('loading.facebox')
    },

    init: function(settings) {
      init(settings);
    },

    showOverlay: function() {
      showOverlay();
    },

    reveal: function(data, klass) {
      $('#facebox .content').empty().html(data);

      this.show();
      this.position();

      $(document).bind('keydown.facebox', function(e) {
        if (e.keyCode == 27) $.facebox.close()
        return true;
      });
    },

    show: function() {
      $('#facebox').show()
    },

    position: function() {
      this.positionTop();
      this.positionLeft();
      addResizeListener(document.getElementById('facebox'), this.positionLeft);
    },

    positionLeft: function() {
      $('#facebox').css(
        'left', $(window).width() / 2 - ($('#facebox').outerWidth() / 2)
      );
    },

    positionTop: function() {
      var windowHeight = $(window).height()
      var modalHeight = $('#facebox').outerHeight()
      if (modalHeight < windowHeight) {
        $('#facebox').css(
          'top', ((windowHeight - modalHeight) / 2) + getPageScroll()[1]
        );
      } else {
        $('#facebox').css(
          'top', getPageScroll()[1]
        );
      }
    },

    close: function(options) {
      options = options || {};
      removeResizeListener(document.getElementById('facebox'), this.positionLeft);
      $(document).trigger('close.facebox', {animate: options.animate !== false})

      return false;
    }
  })

  /*
   * Public, $.fn methods
   */

  $.fn.facebox = function(settings) {
    init(settings)

    function clickHandler() {
      $.facebox.loading(true)

      // support for rel="facebox.inline_popup" syntax, to add a class
      // also supports deprecated "facebox[.inline_popup]" syntax
      var klass = this.rel.match(/facebox\[?\.(\w+)\]?/)
      if (klass) klass = klass[1]

      fillFaceboxFromHref(this.href, klass)
      return false
    }

    return this.click(clickHandler)
  }

  /*
   * Private methods
   */

  // called one time to setup facebox on this page
  function init(settings) {
    if ($.facebox.settings.inited) return true
    else $.facebox.settings.inited = true

    $(document).trigger('init.facebox')
    makeCompatible()

    var imageTypes = $.facebox.settings.imageTypes.join('|')
    $.facebox.settings.imageTypesRegexp = new RegExp('\.' + imageTypes + '$', 'i')

    if (settings) $.extend($.facebox.settings, settings)
    $('body').append($.facebox.settings.faceboxHtml)

    var preload = [ new Image() ]
    preload[0].src = $.facebox.settings.loadingImage

    $('#facebox .close').click($.facebox.close)
  }

  // getPageScroll() by quirksmode.com
  function getPageScroll() {
    var xScroll, yScroll;
    if (self.pageYOffset) {
      yScroll = self.pageYOffset;
      xScroll = self.pageXOffset;
    } else if (document.documentElement && document.documentElement.scrollTop) {	 // Explorer 6 Strict
      yScroll = document.documentElement.scrollTop;
      xScroll = document.documentElement.scrollLeft;
    } else if (document.body) {// all other Explorers
      yScroll = document.body.scrollTop;
      xScroll = document.body.scrollLeft;
    }
    return new Array(xScroll,yScroll)
  }

  // Adapted from getPageSize() by quirksmode.com
  function getPageHeight() {
    var windowHeight
    if (self.innerHeight) {	// all except Explorer
      windowHeight = self.innerHeight;
    } else if (document.documentElement && document.documentElement.clientHeight) { // Explorer 6 Strict Mode
      windowHeight = document.documentElement.clientHeight;
    } else if (document.body) { // other Explorers
      windowHeight = document.body.clientHeight;
    }
    return windowHeight
  }

  // Backwards compatibility
  function makeCompatible() {
    var $s = $.facebox.settings

    $s.loadingImage = $s.loading_image || $s.loadingImage
    $s.imageTypes = $s.image_types || $s.imageTypes
    $s.faceboxHtml = $s.facebox_html || $s.faceboxHtml
  }

  // Figures out what you want to display and displays it
  // formats are:
  //     div: #id
  //   image: blah.extension
  //    ajax: anything else
  function fillFaceboxFromHref(href, klass) {
    // div
    if (href.match(/#/)) {
      var url    = window.location.href.split('#')[0]
      var target = href.replace(url,'')
      $.facebox.reveal($(target).clone().show(), klass)

    // image
    } else if (href.match($.facebox.settings.imageTypesRegexp)) {
      fillFaceboxFromImage(href, klass)
    // ajax
    } else {
      fillFaceboxFromAjax(href, klass)
    }
  }

  function fillFaceboxFromImage(href, klass) {
    var image = new Image()
    image.onload = function() {
      $.facebox.reveal('<div class="image"><img src="' + image.src + '" /></div>', klass)
    }
    image.src = href
  }

  function fillFaceboxFromAjax(href, klass) {
    $.get(href, function(data) { $.facebox.reveal(data, klass) })
  }

  function skipOverlay() {
    return $.facebox.settings.overlay == false || $.facebox.settings.opacity === null
  }

  function showOverlay() {
    if (skipOverlay()) return;
    if ($('#facebox_overlay').length == 0)
      $("body").append('<div id="facebox_overlay" class="facebox_hide"></div>')

    $('#facebox_overlay').addClass("facebox_overlayBG")
      .css('opacity', $.facebox.settings.opacity)
      .click(function() { $(document).trigger('close.facebox') });
    return false
  }

  function hideOverlay() {
    if (skipOverlay()) return;
    $("#facebox_overlay").removeClass("facebox_overlayBG")
    $("#facebox_overlay").addClass("facebox_hide")
    $("#facebox_overlay").remove();

    return false;
  }

  /*
   * Bindings
   */

  $(document).bind('close.facebox', function(event) {
    $(document).unbind('keydown.facebox');
    $('#facebox').hide();
    hideOverlay();
    $('#facebox .loading').remove()
  })

})($);
